import { t } from 'i18next';
import { useFormContext } from 'react-hook-form';
import { Form } from '@anytag/shared-atoms';
import { useUserRoles } from '@anytag/auth';
import { SocialAccountStatus } from '@anytag/graphql';
import { isIndonesiaCountry } from '@anytag/shared-utils';
import {
  NameField,
  EmailField,
  ReasonField,
  GendersField,
  CountryField,
  IntroduceField,
  PhoneNumberField,
  DateOfBirthField,
  AccountTypeField,
  NotificationField,
  CampaignDisplayField,
  RegionAndProvinceField,
  InfluencerCategoriesField,
  TalentAgencyPartnerField
} from '../../shared';
import { InfluencerFormValues } from '../schema-types';

export const InfluencerAccountSection = () => {
  const {
    watch,
    formState: { defaultValues }
  } = useFormContext<InfluencerFormValues>();
  const { isPartner, isAdmin, isTalentAgencyPartner } = useUserRoles();

  const values = watch();
  const influencerId = values?.id;
  const isEditMode = !!influencerId;
  const isSignedUp = values.status === SocialAccountStatus.SIGNED_UP;
  const hasSelectedAgency = !!defaultValues?.partnerIds?.length || !!defaultValues?.talentAgencyIds?.length;
  const hasTalentAgencyField = isPartner ? !hasSelectedAgency || !!values.talentAgencyOrPartnerIds.length : true;

  return (
    <>
      <Form.SectionTitle className="mt-6 mb-0" label={t('Influencer Account')} />
      <NameField required />
      <Form.Fields itemsPerRow={2}>
        <InfluencerCategoriesField required />
        <GendersField required />
      </Form.Fields>
      <Form.Fields itemsPerRow={isIndonesiaCountry(values.countryId) ? 3 : 2}>
        <CountryField disabled={isSignedUp} required />
        <RegionAndProvinceField />
      </Form.Fields>
      <Form.Fields itemsPerRow={2}>
        <EmailField />
        <PhoneNumberField />
      </Form.Fields>
      <DateOfBirthField />
      {hasTalentAgencyField ? <TalentAgencyPartnerField disabled={isPartner ? hasSelectedAgency : !isAdmin} /> : null}
      <IntroduceField />
      <ReasonField />
      <NotificationField />
      <AccountTypeField disabled={isTalentAgencyPartner} required />
      {isSignedUp && isEditMode ? <CampaignDisplayField required /> : null}
    </>
  );
};
